import { Fragment } from 'react';

import useApparelFormGrid from './UseApparelFormGrid';

import ApparelFormGridLarge from './ApparelFormGridLarge';
import ApparelFormGridSmall from './ApparelFormGridSmall';

import Spinner from '@usas/ui-web/components/spinners/Spinner';
import PrimaryButton from '@usas/ui-web/components/buttons/PrimaryButton';
import SecondaryButton from '@usas/ui-web/components/buttons/SecondaryButton';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const ApparelFormGrid = ({ gridData, personId, competitionGenderTypeCode, onSubmitFormCallback, onIsDirtyChanged = undefined, onErrorCaught = undefined }) => {
  const {
    isLoading,
    isDirty,
    formGridState,
    errorState,
    onUpdateApparelGender,
    onUpdateApparelSize,
    onSubmitFormGrid,
    onCancelClicked
  } = useApparelFormGrid(gridData, personId, competitionGenderTypeCode, onSubmitFormCallback, onIsDirtyChanged, onErrorCaught);

  if (isLoading === true) {
    return <Spinner />;
  }

  return (
    <Fragment>
      <ApparelFormGridLarge formGridState={formGridState} onUpdateApparelGender={onUpdateApparelGender} onUpdateApparelSize={onUpdateApparelSize} />
      <ApparelFormGridSmall formGridState={formGridState} onUpdateApparelGender={onUpdateApparelGender} onUpdateApparelSize={onUpdateApparelSize} />
      {errorState &&
        <div className="row">
          <div className="col-xs-12">
            <p className={global.ErrorMessage}>{errorState}</p>
          </div>
        </div>
      }
      <div className="row">
        <div className="col-xs-12 usas-extra-top-margin usas-extra-bottom-margin">
          <PrimaryButton type="button" isDisabled={isDirty === false} onClick={onSubmitFormGrid}>Save</PrimaryButton>&nbsp;
          {isDirty === true && <SecondaryButton type="button" onClick={onCancelClicked}>Cancel</SecondaryButton>}
        </div>
      </div>
    </Fragment>
  );
};

export default ApparelFormGrid;